import { Flex, rem, Text } from '@mantine/core';

interface Props {
	message: string;
}

export const DetailsCardEmptyState = ({ message }: Props) => (
	<Flex mih={rem(156)} align="center" justify="center" p="0.5rem">
		<Text fz={14} c="gray.9" ta="center">
			{message}
		</Text>
	</Flex>
);
